import { UserRole } from './user-role.model';

export class UserLogin {
  constructor(userName?: string, id?: number, password?: string, rememberMe?: boolean, roles?: UserRole[]) {
    this.Id = id;
    this.UserName = userName;
    this.Password = password;
    this.RememberMe = rememberMe;
    this.Roles = [];
  }
  BranchId?: number;
  Id: number;
  UserName: string;
  Password: string;
  Roles: UserRole[];
  RememberMe?: boolean;
}
